var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:_vm.visible ? '' : 'k-sr-only',attrs:{"aria-atomic":String(_vm.atomic),"aria-live":_vm.live,"role":_vm.role}},'div',_vm.$attrs,false),[_vm._v("\n\t"+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }